
<div class="wrapper">
    <div class="panelHolder">
     <div class="panel">
        
        <div class="panel-body-error">
            
            <p>Error occured. Please contact Administrator</p>
            <p>{{errorDescription}}</p>
        </div>
    </div> 
    </div>
    </div>